import React from 'react';
import { lazy } from 'react';

function lazyCrud(configKey, extraProps = {}) {
  return lazy(() =>
    Promise.all([
      import('../pages/admin/modules/AdminCrudPage'),
      import('../pages/admin/modules/moduleConfigs'),
    ]).then(([crud, configs]) => ({
      default: () => <crud.default {...configs[configKey]} {...extraProps} />,
    }))
  );
}

// Páginas públicas — Home síncrona (LCP); restantes lazy para reduzir o bundle inicial
export { default as Home } from '../pages/Home';
export const About = lazy(() => import('../pages/About'));
export const ServiceDetail = lazy(() => import('../pages/ServiceDetail'));
export const Blog = lazy(() => import('../pages/Blog'));
export const PostDetail = lazy(() => import('../pages/PostDetail'));
export const Contact = lazy(() => import('../pages/Contact'));
export const Recruitment = lazy(() => import('../pages/Recruitment'));
export const JobDetail = lazy(() => import('../pages/JobDetail'));
export const JobApplication = lazy(() => import('../pages/JobApplication'));
export const SpontaneousApplication = lazy(() => import('../pages/SpontaneousApplication'));
export const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
export const TermsOfService = lazy(() => import('../pages/TermsOfService'));
export const NotFound = lazy(() => import('../pages/NotFound'));

// Admin — auth e layout
export const AdminLogin = lazy(() => import('../pages/admin/Login'));
export const ResetPassword = lazy(() => import('../pages/admin/ResetPassword'));
export const CorporateLayout = lazy(() => import('../components/layout/CorporateLayout'));
export const CorporateDashboard = lazy(() => import('../pages/admin/CorporateDashboard'));
export const AdminDashboard = lazy(() => import('../pages/admin/Dashboard'));
export const HRDashboard = lazy(() => import('../pages/admin/HRDashboard'));
export const Employees = lazy(() => import('../pages/admin/Employees'));

// Admin — CMS
export const AdminPosts = lazy(() => import('../pages/admin/content/PostList'));
export const PostEditorPage = lazy(() => import('../pages/admin/content/PostEditorPage'));
export const CategoryManager = lazy(() => import('../pages/admin/content/CategoryManager'));
export const MediaLibrary = lazy(() => import('../pages/admin/content/MediaLibrary'));
export const AdminServices = lazyCrud('servicesConfig');
export const AdminJobs = lazyCrud('jobsConfig');
export const AdminApplications = lazyCrud('applicationsConfig', { canCreate: false, canDelete: false });
export const AdminMessages = lazyCrud('messagesConfig', { canCreate: false });
export const AdminNewsletter = lazyCrud('newsletterConfig');

// Admin — core
export const AuthManager = lazy(() => import('../pages/admin/core/AuthManager'));
export const UsersManager = lazy(() => import('../pages/admin/core/UsersManager'));
export const DashboardManager = lazy(() => import('../pages/admin/core/DashboardManager'));
export const RolesManager = lazy(() => import('../pages/admin/core/RolesManager'));

// Admin — CRM
export const TicketsManager = lazy(() => import('../pages/admin/crm/TicketsManager'));
export const ChatManager = lazy(() => import('../pages/admin/crm/ChatManager'));
export const ClientsManager = lazy(() => import('../pages/admin/crm/ClientsManager'));
export const CRMReportsManager = lazy(() => import('../pages/admin/crm/ReportsManager'));

// Admin — presença
export const AttendanceManager = lazy(() => import('../pages/admin/presence/AttendanceManager'));
export const LeaveManager = lazy(() => import('../pages/admin/presence/LeaveManager'));
export const ProductionManager = lazy(() => import('../pages/admin/presence/ProductionManager'));
export const PresenceReportsManager = lazy(() => import('../pages/admin/presence/ReportsManager'));
export const EmployeeList = lazy(() => import('../pages/admin/presence/EmployeeList'));
export const EmployeeProfile = lazy(() => import('../pages/admin/presence/EmployeeProfile'));
export const ProjectManager = lazy(() => import('../pages/admin/presence/ProjectManager'));
export const LeaveBalances = lazy(() => import('../pages/admin/presence/LeaveBalances'));
export const LeavePolicies = lazy(() => import('../pages/admin/presence/LeavePolicies'));
export const PerformanceReviews = lazy(() => import('../pages/admin/presence/PerformanceReviews'));
export const OrgChart = lazy(() => import('../pages/admin/presence/OrgChart'));

// Admin — mail
export const Inbox = lazy(() => import('../pages/admin/mail/Inbox'));
export const Compose = lazy(() => import('../pages/admin/mail/Compose'));
export const Sent = lazy(() => import('../pages/admin/mail/Sent'));
export const Drafts = lazy(() => import('../pages/admin/mail/Drafts'));
export const MailSettings = lazy(() => import('../pages/admin/mail/Settings'));
export const Attachments = lazy(() => import('../pages/admin/mail/Attachments'));

// Admin — analytics
export const AnalyticsDashboard = lazy(() => import('../pages/admin/analytics/AnalyticsDashboard'));
export const HRAnalytics = lazy(() => import('../pages/admin/analytics/HRAnalytics'));
export const CRMAnalytics = lazy(() => import('../pages/admin/analytics/CRMAnalytics'));
export const AnalyticsReportsManager = lazy(() => import('../pages/admin/analytics/ReportsManager'));
export const VisitorAnalytics = lazy(() => import('../pages/admin/analytics/VisitorAnalytics'));
export const PowerBIDashboard = lazy(() => import('../pages/admin/analytics/PowerBIDashboard'));

// Admin — módulos CRUD (financeiro, tech, comunicação, integrações)
export const FinanceBudgets = lazyCrud('financeBudgetConfig');
export const FinanceInvoices = lazyCrud('financeInvoiceConfig');
export const FinanceExpenses = lazyCrud('financeExpenseConfig');
export const TechInfra = lazyCrud('techInfraConfig');
export const TechSystems = lazyCrud('techSystemConfig');
export const TechSecurity = lazyCrud('techSecurityConfig');
export const TechCompliance = lazyCrud('techComplianceConfig');
export const CommMarketing = lazyCrud('commMarketingConfig');
export const CommCampaigns = lazyCrud('commCampaignConfig');
export const CommDesign = lazyCrud('commDesignConfig');
export const IntegrationApis = lazyCrud('integrationApiConfig');
export const IntegrationLogs = lazyCrud('integrationLogsConfig');
export const IntegrationSync = lazyCrud('integrationSyncConfig');

export const AuditLog = lazyCrud('financeBudgetConfig', {
  title: 'Auditoria',
  apiPath: 'configuracoes/auditoria',
  canCreate: false,
  canEdit: false,
  canDelete: false,
  columns: [
    { key: 'action', label: 'Acção' },
    { key: 'entity', label: 'Entidade' },
    { key: 'created_at', label: 'Data' },
  ],
  fields: [],
});

export const FinanceReports = lazyCrud('financeBudgetConfig', { title: 'Relatórios Financeiros' });
